import {useContext} from 'react';
import {GlobalNotificationsContext} from './globalNotificationsProvider';

function useGlobalNotificationsError() {
  const {error, hasError, addError, removeError} = useContext(GlobalNotificationsContext);
  return {error, hasError, addError, removeError};
}

export default useGlobalNotificationsError;
